import React, { useState } from "react";
import { Form, Input, Button, message, DatePicker, Select } from "antd";
//import app from "../firebaseConfig";
import { withRouter } from "react-router";
import { socialLogin, UserRegister } from "../firebase/auth";
import Cargando from "../components/Cargando";
import { GoogleOutlined } from "@ant-design/icons";
import FirebaseApp from "../firebase/context";

const Signup = ({ setsignup, history }) => {
  const { Option } = Select;
  const googleAuthProvider = new FirebaseApp.auth.GoogleAuthProvider();
  const [loading, setLoading] = useState(false);
  const handleSignUp = async (values) => {
    setLoading(true);

    const {
      email,
      password,
      name,
      lastname,
      gender,
      typeUser,
      phoneNumber,
      date,
    } = values;
    const res = await UserRegister({
      email,
      password,
      name,
      lastname,
      gender,
      estado: false,
      typeUser: { value: typeUser },

      country: "",
      aboutMe: "",
      photoURL: "",
      phoneNumber,
      beeoroLink: "",
      academicTraining: [],
      appointmentsAvailable: [],
      attentionAreas: [],
      therapeuticWorkModel: [],
      workExperience: [],
      paid: false,
    });
    if (res.isError) {
      message.error(res.message);
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <Form className="login-form" layout="vertical" onFinish={handleSignUp}>
      <h1>Registro</h1>

      {loading && <Cargando />}

      <Form.Item
        className="aligin-center"
        label="Nombre"
        name="name"
        rules={[
          {
            required: true,
            message: "Por favor ingrese su nombre!",
          },
        ]}
      >
        <Input placeholder="Nombre" />
      </Form.Item>
      <Form.Item
        className="aligin-center"
        label="Apellido"
        name="lastname"
        rules={[
          {
            required: true,
            message: "Por favor ingrese su apellido!",
          },
        ]}
      >
        <Input placeholder="Apellido" />
      </Form.Item>
      <Form.Item
        className="aligin-center"
        label="Correo"
        name="email"
        rules={[
          {
            required: true,
            message: "Por favor ingrese su correo!",
          },
        ]}
      >
        <Input placeholder="Correo" />
      </Form.Item>
      <Form.Item
        className="aligin-center"
        label="Contraseña"
        name="password"
        rules={[
          {
            required: true,
            message: "Por favor ingrese su contraseña!",
          },
        ]}
      >
        <Input.Password placeholder="Contraseña" type="password" />
      </Form.Item>
      <div>Información personal</div>

      <Form.Item
        className="aligin-center"
        name="gender"
        label="Género"
        rules={[
          {
            required: true,
            message: "Por favor ingrese el género!",
          },
        ]}
      >
        <Select placeholder="Seleccione su género">
          <Option value="Hombre">Hombre</Option>
          <Option value="Mujer">Mujer</Option>
          <Option value="Otro">Otro</Option>
        </Select>
      </Form.Item>
      <Form.Item
        className="aligin-center"
        name="typeUser"
        label="Tipo de cuenta"
        rules={[
          {
            required: true,
            message: "Por favor ingrese el tipo de cuenta!",
          },
        ]}
      >
        <Select placeholder="Tipo de cuenta">
          <Option value="paciente">Usuario</Option>
          <Option value="psicologo">Profesional</Option>
        </Select>
      </Form.Item>

      <Form.Item
        className="aligin-center"
        label="Celular"
        name="phoneNumber"
        rules={[
          {
            required: true,
            message: "Por favor ingrese su celular!",
          },
        ]}
      >
        <Input placeholder="Celular" />
      </Form.Item>
      <div>
        <Button
          style={{ backgroundColor: "white" }}
          onClick={() => setsignup(false)}
          type="link"
        >
          Ingresa ahora!
        </Button>
        O{" "}
        <Button
          type="primary"
          htmlType="submit"
          className="login-form-button"
          style={{ marginRight: 10 }}
        >
          Registrate
        </Button>
      </div>
    </Form>
  );
};

export default withRouter(Signup);
